<template>
    <section class="Block Workflowphase Overview" :class="{loading: viewData.loading, [this.layout]: true}">
        <ul class="block-grid one-up">
            <li>
                <template v-if="!viewData.loading && !viewData.data.length">
                    <div class="noitems">{{ trans("Momenteel is er geen data beschikbaar.") }}</div>
                </template>
                <article v-else class="Block Workflowphase Item" :class="{[this.layout]: true}">
                    <div class="inner">
                        <workflowcard-item v-for="(item, index) in viewData.data"
                           :key="item.id"
                           :data="item"
                           :layout="this.layout"
                           :workflowboard_id="this.workflowboard_id"
                           :workflowphase_id="this.workflowphase_id"
                           :first="index === 0"
                           :icon_buttons_by_role="true"
                        >
                            <template #workflowcard_item_actions="{data, layout}">
                                <slot name="workflowcard_item_actions" :data="data" :layout="layout" />
                            </template>
                        </workflowcard-item>
                    </div>
                </article>
            </li>
        </ul>
    </section>
</template>

<script>
import {defineComponent, inject, onMounted, watch} from "vue";

import workflowcardItem from "view/dashboard/includes/workflowcard-item";

import trans from "helpers/_translation";

export default defineComponent({
    name: "workflowphase-list",
    components: {
        workflowcardItem
    },
    props: {
        layout: {
            type: String,
            required: false,
            default: "tabular"
        },
        workflowboard_id: {
            type: String,
            required: true
        },
        workflowphase_id: {
            type: String,
            required: true
        },
        icon_buttons_by_role: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        // Our configuration and constants
        const viewData = inject("viewData");

        return {
            trans,
            viewData
        };
    },
});

</script>
